import { Grid, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { RecordHeader } from "@ofqual/portal-components/components/RecordHeader";
import { NonNullableItemState } from "../../redux/state";
import {
  formatUtcDate,
  standardDateFormats,
} from "@ofqual/portal-core/core/utils/dateUtils";
import { ApplicationStatus } from "../../domain/ExpertsApplyFormModel";

const useStyles = makeStyles(() => {
  return {
    gridItem: {
      borderRight: "1px solid rgba(255,255,255,0.2)",
      padding: "0 15px",
      "& div": {
        padding: "5px",
      },
    },
  };
});

type ItemHeaderProps = {
  state: NonNullableItemState | null;
};

export const ItemHeader: React.FC<ItemHeaderProps> = ({ state }) => {
  const classes = useStyles();

  const [statusText, setStatusText] = useState<string>("");
  useEffect(() => { 
    if (state?.item?.applicationStatus === ApplicationStatus["Evaluation partially approved"] || 
      state?.item?.applicationStatus === ApplicationStatus["Evaluation approved"]) {
      setStatusText("Evaluation approved");
    }
    else
    {
      setStatusText(ApplicationStatus[state?.item?.applicationStatus || 0]);
    }
  }, [setStatusText, state?.item]);

  return (
    <RecordHeader>
      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="stretch"
        spacing={2}
        style={{ height: "100%" }}
      >
        <Grid className={classes.gridItem}>
          <div>
            <label>
              <strong>Title:</strong>
            </label>{" "}
            <span data-test="metadata-acronym">
              {state && state.item?.referenceNumber}
            </span>
          </div>
          <div>
            <label>
              <strong>Submitted date:</strong>
            </label>{" "}
            <span data-test="metadata-acronym">
              {state && state.item?.submittedDate !== undefined
                ? formatUtcDate(
                    state.item?.submittedDate,
                    standardDateFormats.DATE
                  )
                : "Not Submitted"}
            </span>
          </div>
        </Grid>
        <Grid className={classes.gridItem}>
          <div>
            <label>
              <strong>Status: </strong>
            </label>
            <span data-test="metadata-status">{statusText}</span>
          </div>
        </Grid>
      </Grid>
    </RecordHeader>
  );
};
